import { DocumentViewerActionTypes } from './action_types'
import { DocumentViewerMutationTypes } from './mutation_types'
import filesService from '../../../services/files.service'

export const actions: StoreActions<DocumentViewerActionTypes, DocumentViewerMutationTypes> = {
  async [DocumentViewerActionTypes.REDACT_DOCUMENT] ({ commit }, { mnemo, fileId, data }) {
    commit(DocumentViewerMutationTypes.SET_REDACT_DOCUMENT_ERROR, null)
    try {
      await filesService.redactDocument(mnemo, fileId, data)
    } catch (error) {
      commit(DocumentViewerMutationTypes.SET_REDACT_DOCUMENT_ERROR, error)
      throw error
    }
  },
}
